import { createApi } from '@reduxjs/toolkit/query/react';
import { GenericResponse } from '@/redux/models';
import customFetchBase from './customFetchBase';

export type CarrouselItem = {
    id: number,
    image_url: string,
    position: number,
    nombre: string,
}

export const ConfiguracionApi = createApi({
    reducerPath: 'CarrouselApi',
    baseQuery: customFetchBase,
    tagTypes: ['carrousel'],
    endpoints: (builder) => ({
        //CARROUSEL
        obtenerFotos: builder.query<CarrouselItem[], void>({
            query: () => ({
                url: 'archivo/getLogos',
                method: 'GET',
                credentials: 'include',
            }),
            transformResponse: (response: GenericResponse) => {
                const listaRaw = response.data
                return listaRaw.map((item: any) => ({
                    id: item.logoArchivoId,
                    nombre: item.nombreLogo,
                    position: item.posicion,
                    image_url: item.link,
                })) as CarrouselItem[];
            },
        }),
        subirFoto: builder.mutation<GenericResponse, FormData>({
            query: (data) => ({
                url: 'archivo/addLogo',
                method: 'POST',
                credentials: 'include',
                body: data,
            }),
        }),
        eliminarFoto: builder.mutation<GenericResponse, number>({
            query: (idLogo) => ({
                url: 'archivo/deleteLogo',
                method: 'DELETE',
                credentials: 'include',
                params: {
                    idLogo: idLogo
                }
            }),
        }),
          
        //END-CARROUSEL

        cambiarEmail: builder.mutation<GenericResponse, string>({
            query: (email) => ({
                url: 'email/cambiarEmailRecepcion',
                method: 'POST',
                credentials: 'include',
                params: {
                    email: email
                }
            }),
        }),

        inicializarPrecios: builder.mutation({
            query: () => ({
                url: 'precio/inicializarPrecios',
                method: 'POST',
                credentials: 'include',
            }),
        }),
    }),
});

export const {
    useObtenerFotosQuery,
    useSubirFotoMutation,
    useCambiarEmailMutation,
    useEliminarFotoMutation,
    useInicializarPreciosMutation
} = ConfiguracionApi;
